// pages/PartnerLeadsPage.jsx
//
// Vista de "Leads Details" para un partner/afiliado específico, usada tanto
// desde el nav principal (sin filtro) como desde PartnersPage (con
// ?partner_aff_id=<aff_id> para ver solo los leads de ese afiliado).
//
// Reutiliza AdminLeadsDashboard con lockedOrigin en vez de llamar a un
// endpoint propio: la página original pegaba a `/partner-leads`, que ya no
// existe en el backend actual (ver issue #2).
import React from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import AdminLeadsDashboard from './AdminLeadsDashboard.jsx'

export default function PartnerLeadsPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const partnerAffId = searchParams.get('partner_aff_id') || null

  return (
    <div>
      <button
        className="btn btn-ghost btn-icon"
        style={{ marginBottom: 12 }}
        onClick={() => navigate('/affiliates')}
      >
        ←
      </button>
      <AdminLeadsDashboard
        lockedOrigin={partnerAffId}
        pageTitle={partnerAffId ? `Leads Details: ${partnerAffId}` : 'Leads Details'}
        pageSubtitle={partnerAffId ? 'dedicated view · this partner only' : null}
      />
    </div>
  )
}
